import React from "react";
import ItemDetails from '../common/ItemDetails';
import QuantityUpdater from "../../containers/common/QuantityUpdater";
import {formatMoney, getDistributionsNumber, getItemPrice} from "../../common/basket";
import {translate} from '../../i18n/translate.js';
import {URLs} from "../../common/constants";

class SummaryItem extends React.Component {
    state = {
        showDetails: false
    };

    getPrice = (item) => {
        const itemPrice = getItemPrice(item, this.props.staticData, (this.props.pickupSite || {}).key);
        //In Account and add-subscription need to show the price after tax
        let calcPrice = this.props.includeTax ? itemPrice.fullPrice : itemPrice.priceBeforeTax;
        if(this.props.isFarmSeasonal && this.props.staticData.hideDeliveryPrice){
            const distributionsNumber = getDistributionsNumber(item, item.selectedSchedule);
            calcPrice = item.selectedSchedule || item.schedules.length === 1 ? calcPrice * (distributionsNumber ? distributionsNumber : 1) : undefined;
        }
        return calcPrice;
    };

    onRemoveButtonClick = () => {
		this.props.onRemoveItem(this.props.item.key, this.props.item.minQuantity||0);
	};

    setItemPriceView = (item, distributionsNumber) => {
        const totalPrice = item.isCredit ? item.quantity * item.price : formatMoney(item.quantity * this.getPrice(item) * distributionsNumber);
        const noPrice = totalPrice === '$0.00';
        let element;
        if (item.waitList) {
            element = <span className="waitlist">{translate("Waitlist")}</span>
        } else if (noPrice) {
            element = <span className="no-price"/>
        } else {
            element = <span className="order-summary-item-total" name="orderSummaryItemTotal">{totalPrice}</span>
        }
        if (this.props.flowType !== URLs.ACCOUNT || !this.props.staticData.hideDeliveryPrice) {
            return (<div className={"join-summary-item-total" + (noPrice ? " no-price" : "")}>{element}</div>)
        }
    };

    closeDetails = () => {
        this.setState({showDetails: false})
    };

    getItemDetails = () => {
        if(this.state.showDetails){
            return (
                <ItemDetails item={this.props.item}
                             staticData={this.props.staticData}
                             clientViewPort={this.props.clientViewPort}
                             shouldShowQuantityUpdater={false}
                             closeDetails={this.closeDetails}/>
            )
        }else{
            return '';
        }
    };

    openDetails = () => {
        if (this.props.showItemDetailsLink)
            this.setState({ showDetails: true });
    };

    render() {
        let item = this.props.item || {};
        let scheduleIndex = item.selectedSchedule ? item.schedules.indexOf(item.selectedSchedule) : 0;
        let distributionsNumber = item.weeksLeft ? item.weeksLeft[scheduleIndex] : undefined;
        const creditItemLabel = this.props.staticData.creditItemLabel;
        const formattedPrice = formatMoney(this.getPrice(item));
        const noPrice = formattedPrice === '$0.00';
        const selectedSchedule = item.selectedSchedule ? this.props.schedules[item.selectedSchedule] || {} : {};
		return (
            <div className="order-summary-item-wrapper">
                <div className="order-summary-item">
                    <div className={"title" + (this.props.showItemDetailsLink ? " details-link" : "")} onClick={this.openDetails} name="orderSummaryItemName">{item.title}</div>
                    {noPrice ?
                        undefined
                        :
                        <div className="price" name="orderSummaryItemPrice"><b>{formattedPrice}</b>  /  {item.unitQuantity === 1 ? '' : item.unitQuantity} {item.unit?item.unit.replace("credits",creditItemLabel):item.unit}</div>
                    }
                    <div className="text-left">{(item.schedules.length > 1 || selectedSchedule.isOnce) && item.selectedSchedule? (this.props.schedules[item.selectedSchedule] || {}).title : ''}</div>
                    {distributionsNumber ?
                        <div className="text-left">{(this.props.isFarmSeasonal && distributionsNumber && distributionsNumber > 1)? distributionsNumber + " " + translate('Distributions') : ''}</div>
                        : undefined
                    }
                </div>
                <div className={"order-summary-item-qty" + (noPrice ? " no-price" : "")}>
                    {this.props.readOnly ?
                        <div className="quantity read-only">{item.quantity}</div>
                        :
                        <QuantityUpdater item={item} isOrderSummary={true} isJoinFlow={true} allowChange={true} staticData={this.props.staticData}/>
                    }
                </div>
                {this.setItemPriceView(item, distributionsNumber&& this.props.isFarmSeasonal&&!this.props.staticData.hideDeliveryPrice?distributionsNumber:1)}
                {this.props.readOnly ?
                    undefined
                    :
                    <button className="close-button order-summary-item-remove" name="btnOrderSummaryItemRemove" onClick={this.onRemoveButtonClick}/>
                }
                {this.getItemDetails()}
            </div>
		)
	}
}

export default SummaryItem;


// WEBPACK FOOTER //
// ./src/components/summary/SummaryItem.js